import { Icon, ListItem, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
// import IntlMessages from "@crema/helpers/IntlMessages";
import Box from "@mui/material/Box";
// import AppNavLink from "../../../AppNavLink";
import Badge from "@mui/material/Badge";
// import { RouterConfigData } from "@crema/types/models/Apps";
import { NavItemProps as RouterConfigData } from 'modules/routesConfig';
// import { useSidebarContext } from "@crema/context/AppContextProvider/SidebarContextProvider";
import AppNavLink from "@crema/core/AppNavLink";
import IntlMessages from "@crema/utility/IntlMessages";
import AppContext from "@crema/utility/AppContext";
import { useContext, useMemo } from "react";
import { isUrlInChildren, navListItemStyle } from ".";
import { checkPermission } from "@crema/utility/Utils";

type HorizontalItemProps = {
  item: RouterConfigData;
  nestedLevel?: number;
  dense?: boolean;
};

const HorizontalItem: React.FC<HorizontalItemProps> = (props) => {
  const { item, dense, nestedLevel } = props;
  const isMenuTop = useMemo(() => nestedLevel === 0, [nestedLevel])
  const location = useLocation();
  const active = isUrlInChildren(item, location.pathname);
  // const { sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor } =
  //   useSidebarContext();
  const { theme, sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor, HPUser } = useContext(AppContext)

  const hasPermission = useMemo(
    () => checkPermission(item.auth, HPUser!.ruoli),
    [
      item.auth,
      HPUser,
    ],
  );

  if (!hasPermission) {
    return null;
  }

  return (
    <ListItem
      component={AppNavLink}
      to={item.url}
      activeClassName="active"
      className={clsx("navItemSubmenu", dense && "dense")}
      exact={item.exact}
      sx={{
        minHeight: 40,
        padding: "4px 12px",
        color: theme.palette.sidebar.textColor,
        textDecoration: "none!important",
        fontSize: '1rem',
        // minWidth: 160,
        "&.active": {
          backgroundColor: sidebarMenuSelectedBgColor,
          color: sidebarMenuSelectedTextColor + " !important",
          // pointerEvents: "none",
          // "& .list-item-text-primary": {
          //   color: "inherit",
          // },
          // "& .list-item-icon": {
          //   color: "inherit",
          // },
        },
        "& .list-item-text": {
          padding: "0 0 0 16px",
        },
        "&.dense": {
          padding: "4px 12px",
          minHeight: 40,
          "& .list-item-text": {
            padding: "0 0 0 8px",
          },
        },

        ...navListItemStyle,
        // ':hover': {
        //   backgroundColor: 'rgba(0,0,0,.08)',
        // },
        
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
          opacity: 0,
          transition: 'opacity 0.3s',
          pointerEvents: 'none',
          borderRadius: 'inherit',
        },
        '&:hover::before': {
          opacity: 1,
        },
      }}
    >
      {!isMenuTop && item.icon && (
        // <Icon
        //   sx={{
        //     color: active ? sidebarMenuSelectedTextColor : "action",
        //     mr: 3,
        //     fontSize: { xs: 16, xl: 18 },
        //   }}
        // >
        //   {item.icon}
        // </Icon>
        // <Icon
        //   sx={(theme) => ({
        //     // color: active ? sidebarMenuSelectedTextColor : 'action',
        //     color: active ? sidebarMenuSelectedTextColor : theme.palette.text.primary,
        //     // mr: 3.5,
        //     mr: '8px',
        //     fontSize: {xs: 16, xl: 18},
        //   })}>
        //   {item.icon}
        // </Icon>
        <Icon
          sx={{
            color: active ? sidebarMenuSelectedTextColor : 'action',
            mr: '8px',
            fontSize: { xs: 16, xl: 18 },
          }}
        >
          {item.icon}
        </Icon>
      )}
      <ListItemText
        className="AppNavLinkTextSubmenu"
        primary={<IntlMessages id={item.messageId} />}
        primaryTypographyProps={{
          noWrap: true,
          fontWeight: 500,
        }}
      />
      {item.count && (
        <Box ml={4}>
          <Badge
            badgeContent={item.count}
            sx={{
              color: item.color,
            }}
          />
        </Box>
      )}
    </ListItem>
  );
};

export default HorizontalItem;
